<template>
  <v-dialog v-model="navigation.CRMAgentStickerDialogIsVisible" @update:model-value="navigation.CRMAgentStickerDialogIsVisible == false ? closeCRMAgentStickerDialog() : null" :persistent="loader.generalLoader" max-width="20vw">
    <v-card max-width="20vw">
      <div v-if="loader.generalLoader" style="display: flex; justify-content: center; align-items: center; width: 100%; padding: 10px 0px;">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <div v-else style="padding: 15px;">
        <v-text-field 
          v-if="navigation.insertCRMAgentSticker || navigation.updateCRMAgentSticker"
          ref="CRMAgentStickerName"
          v-model="input.CRMAgentStickerName" 
          :append-inner-icon="input.CRMAgentStickerName && /\S/.test(input.CRMAgentStickerName) ? 'mdi-alphabetical-variant-off' : 'mdi-alphabetical-variant'" 
          @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMAgentStickerName'); input.CRMAgentStickerName = null" 
          label="Nombre del sticker" 
          variant="solo-filled" 
          density="compact"
          autocomplete="off"
          hide-details
          style="margin-bottom: 15px;"
        ></v-text-field>
        <img 
          :src="navigation.insertCRMAgentSticker ? navigation.CRMAgentSticker : navigation.CRMAgentSticker.CRMAgentStickerMediaURL"
          draggable="false"
          style="max-width: 100%; height: auto;"
        >
        <v-tooltip :disabled="validateInputForCRMAgentStickerDialog(false).success" location="top"> 
          <template v-slot:activator="{ props }">
            <div v-bind="props">
              <v-btn 
                @click="navigation.insertCRMAgentSticker ? insertCRMAgentSticker() : navigation.updateCRMAgentSticker ? updateCRMAgentSticker() : deleteCRMAgentSticker()" 
                :disabled="!validateInputForCRMAgentStickerDialog(false).success" 
                :color="navigation.insertCRMAgentSticker ? 'success' : navigation.updateCRMAgentSticker ? 'warning' : 'error'" 
                dark 
                block 
                height="38" 
                style="margin-top: 15px;"
              >
                <h3>{{ navigation.insertCRMAgentSticker ? 'AGREGAR' : navigation.updateCRMAgentSticker ? 'ACTUALIZAR' : 'ELIMINAR' }} STICKER</h3>
                <v-icon style="margin-left: 10px;" dark right>{{ navigation.insertCRMAgentSticker ? 'mdi-plus-circle' : navigation.updateCRMAgentSticker ? 'mdi-pencil' : 'mdi-delete' }}</v-icon>
              </v-btn>
            </div>
          </template>
          <span style="max-width: 400px; display: block;">{{ validateInputForCRMAgentStickerDialog(false).result }}</span>
        </v-tooltip>
        <v-btn @click="navigation.CRMAgentStickerDialogIsVisible = false" :color="navigation.deleteCRMAgentSticker ? 'primary' : 'error'" dark block height="38" style="margin-top: 10px;">
          <h3>CANCELAR</h3>
          <v-icon style="margin-left:10px;" dark right>mdi-close-circle</v-icon>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
  
<style scoped>
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    data: () => 
    ({
      input: 
      {
        CRMAgentStickerName: null
      },
      navigation: 
      {
        CRMAgentStickerDialogIsVisible: false,
        insertCRMAgentSticker: false,
        updateCRMAgentSticker: false,
        deleteCRMAgentSticker: false,
        CRMAgentSticker: null
      },
      loader: 
      {
        closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog: false,
        generalLoader: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    methods:
    {

      async insertCRMAgentSticker(){
        if (this.validateInputForCRMAgentStickerDialog(true).success){
          this.loader.generalLoader = true;
          const insertCRMAgentStickerRequestQuery =
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
            },
            'CRMAgentStickerName': this.input.CRMAgentStickerName,
            'CRMAgentStickerMediaURL': this.navigation.CRMAgentSticker
          };
          const insertCRMAgentStickerResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAgent/CRMAgentSticker/functions/insertCRMAgentSticker', insertCRMAgentStickerRequestQuery);
          if (insertCRMAgentStickerResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog(`insertCRMAgentSticker_${this.input.CRMAgentStickerName}_success`, 'success', `Se ha agregado el sticker ${this.input.CRMAgentStickerName}`, null, true);
            this.closeCRMAgentStickerDialog();
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog(`insertCRMAgentSticker_${this.input.CRMAgentStickerName}_error`, 'error', `Ha ocurrido un error inesperado al agregar el sticker ${this.input.CRMAgentStickerName}, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
          }
          this.loader.generalLoader = false;
        }
      },

      async updateCRMAgentSticker(){
        if (this.validateInputForCRMAgentStickerDialog(true).success){
          this.loader.generalLoader = true;
          const updateCRMAgentStickerRequestQuery =
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
            },
            'CRMAgentStickerID': this.navigation.CRMAgentSticker.CRMAgentStickerID,
            'CRMAgentStickerName': this.input.CRMAgentStickerName
          };
          const updateCRMAgentStickerResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAgent/CRMAgentSticker/functions/updateCRMAgentSticker', updateCRMAgentStickerRequestQuery);
          if (updateCRMAgentStickerResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog(`updateCRMAgentSticker_${this.input.CRMAgentStickerName}_success`, 'success', `Se ha actualizado el sticker ${this.input.CRMAgentStickerName}`, null, true);
            this.closeCRMAgentStickerDialog();
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog(`updateCRMAgentSticker_${this.input.CRMAgentStickerName}_error`, 'error', `Ha ocurrido un error inesperado al actualizar el sticker ${this.input.CRMAgentStickerName}, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
          }
          this.loader.generalLoader = false;
        }
      },

      async deleteCRMAgentSticker(){
        if (this.validateInputForCRMAgentStickerDialog(true).success){
          this.loader.generalLoader = true;
          const deleteCRMAgentStickerRequestQuery =
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
            },
            'CRMAgentStickerID': this.navigation.CRMAgentSticker.CRMAgentStickerID,
            'CRMAgentStickerIndex': this.navigation.CRMAgentSticker.CRMAgentStickerIndex
          };
          const deleteCRMAgentStickerResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAgent/CRMAgentSticker/functions/deleteCRMAgentSticker', deleteCRMAgentStickerRequestQuery);
          if (deleteCRMAgentStickerResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog(`deleteCRMAgentSticker_${this.navigation.CRMAgentSticker.CRMAgentStickerName}_success`, 'success', `Se ha eliminado el sticker ${this.navigation.CRMAgentSticker.CRMAgentStickerName}`, null, true);
            this.closeCRMAgentStickerDialog();
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog(`deleteCRMAgentSticker_${this.navigation.CRMAgentSticker.CRMAgentStickerName}_error`, 'error', `Ha ocurrido un error inesperado al eliminar el sticker ${this.navigation.CRMAgentSticker.CRMAgentStickerName}, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
          }
          this.loader.generalLoader = false;
        }
      },    

      validateInputForCRMAgentStickerDialog(showSystemNotificationDialog){
        const regularExpressionChecker = /\S/;
        if (this.navigation.deleteCRMAgentSticker){
          return {success: true, result: null};
        } else if (this.input.CRMAgentStickerName == null || !regularExpressionChecker.test(this.input.CRMAgentStickerName)){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog(`validateInputForCRMAgentStickerDialog_${this.input.CRMAgentStickerName}_missingName_info`, 'info', 'El nombre del sticker es obligatorio', null, false);
          return {success: false, result: 'El nombre del sticker es obligatorio'};
        } else if (this.input.CRMAgentStickerName.length > 100){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog(`validateInputForCRMAgentStickerDialog_${this.input.CRMAgentStickerName}_nameTooLong_info`, 'info', 'El nombre del sticker no puede exceder los 100 caracteres de longitud', null, false);
          return {success: false, result: 'El nombre del sticker no puede exceder los 100 caracteres de longitud'};
        }
        return {success: true, result: null};
      },

      async getSystemInformationData(){
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            if (!this.systemInformationData.updateSubscription){
              this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
                this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
              });
            }          
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('closeCRMWhatsappConversationDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('closeCRMWhatsappConversationDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      },

      async openCRMAgentStickerDialog(insertCRMAgentSticker, updateCRMAgentSticker, deleteCRMAgentSticker, CRMAgentSticker){
        await this.getSystemInformationData();
        this.input.CRMAgentStickerName = updateCRMAgentSticker ? CRMAgentSticker.CRMAgentStickerName : insertCRMAgentSticker ? Array.from({length: 5}, () => String.fromCharCode(65 + Math.floor(Math.random() * 26))).join('') : null;
        this.navigation.CRMAgentSticker = JSON.parse(JSON.stringify(CRMAgentSticker));
        this.navigation.insertCRMAgentSticker = insertCRMAgentSticker;
        this.navigation.updateCRMAgentSticker = updateCRMAgentSticker;
        this.navigation.deleteCRMAgentSticker = deleteCRMAgentSticker;
        this.navigation.CRMAgentStickerDialogIsVisible = true;
        this.$generalFunctions.default.focusInput(this, 'CRMAgentStickerName');
      },

      closeCRMAgentStickerDialog(){
        this.navigation.CRMAgentStickerDialogIsVisible = false;
        this.$emit('closeCRMAgentStickerDialog');
      }
    }
  }
</script>